import { render } from "./SampleAvatar.vue?vue&type=template&id=e61ad712&scoped=true"
import script from "./SampleAvatar.vue?vue&type=script&lang=js"
export * from "./SampleAvatar.vue?vue&type=script&lang=js"

import "./SampleAvatar.vue?vue&type=style&index=0&id=e61ad712&scoped=true&lang=css"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61ad712"]])

export default __exports__